import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { primeUrl, instoStakingUrl, exchangeUrl, internationalExchangeUrl, derivativesUrl, verifiedPoolsUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function InstitutionsColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry;
  const isFranceUser = isUserFromCountry('FR');
  const isUKUser = isUserFromCountry('GB');
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.institutions),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      href: primeUrl,
      accessibilityLabel: formatMessage(titleMessages.prime),
      children: formatMessage(messages.prime)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: instoStakingUrl,
      accessibilityLabel: formatMessage(titleMessages.staking),
      children: formatMessage(messages.staking)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: exchangeUrl,
      accessibilityLabel: formatMessage(titleMessages.exchange),
      children: formatMessage(messages.exchange)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: internationalExchangeUrl,
      accessibilityLabel: formatMessage(titleMessages.internationalExchange),
      children: formatMessage(messages.internationalExchange)
    }), !isFranceUser && !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.derivatives),
      href: derivativesUrl,
      children: formatMessage(messages.derivatives)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      href: verifiedPoolsUrl,
      accessibilityLabel: formatMessage(titleMessages.verifiedPools),
      children: formatMessage(messages.verifiedPools)
    })]
  });
}
const InstitutionsColumn$1 = /*#__PURE__*/memo(InstitutionsColumn);
export { InstitutionsColumn$1 as default };
//# sourceMappingURL=InstitutionsColumn.js.map
